import { getChunkDetailsApi } from '@/controllers/API'
import { Spin, message } from 'antd'
import _ from 'lodash'
import { useCallback, useEffect, useRef, useState } from 'react'

/* chunk_id 接口id */
interface HighlighterComProps {
  chunk_id: string | number // 切片id
  setLoading: any // loading关闭外层
  knowledgeTraceInfo?: any // 从PopoverCont传递过来的知识库溯源信息
}
/* 高亮img组建 = 纯展示img 无功能 */
const HighlighterCom: React.FC<HighlighterComProps> = ({ chunk_id, setLoading, knowledgeTraceInfo }) => {
  const [sliceDataList, setSliceDataList] = useState([]) // [{ imgSrc, highlights }]

  // 图片加载状态
  const [imagesLoaded, setImagesLoaded] = useState(false)
  const canvasRefs = useRef([])
  const containerRef = useRef(null)
  const imageContainerRefs = useRef([])

  const [imageSizeRef, setImageSizeRef] = useState({ width: 1190, height: 1684 }) // 目标图片尺寸
  const [pageImageUrls, setPageImageUrls] = useState([]) // API获取的页面图片URL列表

  const allHighlights = knowledgeTraceInfo?.allHighlights ?? false

  // 加载并渲染图片 + 高亮
  const renderImageWithHighlights = useCallback(
    (imgSrc, highlights, canvasIndex) => {
      return new Promise(resolve => {
        const img = new Image()
        // img.crossOrigin = 'anonymous'
        img.onload = () => {
          const canvas = canvasRefs.current[canvasIndex]
          if (!canvas) {
            resolve(false)
            return
          }

          const ctx = canvas.getContext('2d')
          canvas.width = img.width
          canvas.height = img.height

          ctx.clearRect(0, 0, canvas.width, canvas.height)
          ctx.drawImage(img, 0, 0)

          // 新逻辑：如果实际图片尺寸与预期不同，需要按比例调整
          if (highlights?.length > 0) {
            highlights.forEach(({ x1, y1, x2, y2 }) => {
              const scaleX = canvas.width / imageSizeRef.width
              const scaleY = canvas.height / imageSizeRef.height

              const x = x1 * scaleX
              const y = y1 * scaleY
              const w = (x2 - x1) * scaleX
              const h = (y2 - y1) * scaleY

              // 绘制红色边框
              ctx.strokeStyle = '#FF4D4F'
              ctx.lineWidth = 1 // 使用更细的线宽
              ctx.strokeRect(x, y, w, h)

              // 绘制更透明的填充，减少对文字的遮挡
              ctx.fillStyle = 'rgba(255, 77, 79, 0.15)'
              ctx.fillRect(x, y, w, h)
            })
          }

          // 溯源角标现在通过HTML渲染，不再在canvas上绘制

          resolve(true)
        }

        img.onerror = () => {
          console.error('Image failed to load:', imgSrc)
          resolve(false)
        }

        img.src = imgSrc
      })
    },
    [imageSizeRef]
  )
  console.log(2222222, 'badges', knowledgeTraceInfo?.badges)
  // 渲染有高亮数据的页面到canvas
  useEffect(() => {
    const loadHighlightPages = async () => {
      if (!pageImageUrls.length) return

      const promises = sliceDataList.map(({ imgSrc, highlights, pageNum }, sliceIndex) => {
        // 找到该页面在完整页面列表中的索引
        const pageIndex = pageNum // pageNum是1-based，转为0-based
        return renderImageWithHighlights(imgSrc, highlights, pageIndex)
      })

      await Promise.all(promises)
      setImagesLoaded(true)
    }

    if (sliceDataList.length > 0 && pageImageUrls.length > 0) {
      console.log('开始加载高亮页面，sliceDataList:', sliceDataList)
      const timer = setTimeout(loadHighlightPages, 100)
      return () => clearTimeout(timer)
    }
  }, [sliceDataList, renderImageWithHighlights, pageImageUrls])

  // 内部loading状态
  const [Spinload, setSpinLoading] = useState(false)

  // 目标页面索引，用于自动滚动
  const [targetPageIndex, setTargetPageIndex] = useState<number | null>(null)

  /* 新的坐标转换处理函数 */
  const processNewFormat = detail => {
    if (!detail || detail.length === 0) return []

    const detailItem = detail[0] // 取第一个detail项
    let { box, page_num, image_size } = detailItem
    console.log('cur_trace_file_info', knowledgeTraceInfo?.cur_trace_file_info)

    image_size = [parseInt(image_size[0]), parseInt(image_size[1])]
    if (allHighlights) {
      box = []
      page_num = []
      image_size = knowledgeTraceInfo?.cur_trace_file_info?.image_size
      knowledgeTraceInfo?.cur_trace_file_info?.chunk_index_list.forEach((chunk, index) => {
        // 如果内容引用到了角标
        if (knowledgeTraceInfo?.badges.includes(chunk)) {
          console.log('如果内容引用到了角标', chunk)
          box.push(knowledgeTraceInfo?.cur_trace_file_info?.box_list?.[index])
          page_num.push(knowledgeTraceInfo?.cur_trace_file_info?.page_num_list?.[index])
        }
      })
    }
    if (!box || !page_num || !image_size) return []

    const img_width_zoom = image_size[0]
    const img_height_zoom = image_size[1]
    const pdf_width = img_width_zoom / 2
    const pdf_height = img_height_zoom / 2
    const zoom = 2.0

    // 更新图片尺寸引用
    setImageSizeRef({ width: img_width_zoom, height: img_height_zoom })

    // 按页面分组坐标 结构为key:pageNum value:box[]
    const pageHits = new Map()
    let pageList: number[]
    if (allHighlights) {
      page_num.forEach((pages, index) => {
        pages.forEach((pageItem, i) => {
          if (!pageHits.has(pageItem)) pageHits.set(pageItem, [])
          pageHits.get(pageItem).push(box[index][i])
        })
      })
      pageList = _.uniq(_.flatten(page_num))
    } else {
      box.forEach((boxItem, index) => {
        const pageNum = page_num[index]
        if (!pageHits.has(pageNum)) pageHits.set(pageNum, [])
        pageHits.get(pageNum).push(boxItem)
      })
      pageList = _.uniq(page_num)
    }
    const formatted = pageList.map(pageNum => {
      const url = pageImageUrls[pageNum]
      const boxes = pageHits.get(pageNum) || []

      const highlights = boxes.map(([x, y, w, h]) => {
        // 步骤1: PDF坐标计算
        const x1_pdf = x
        const y1_pdf = pdf_height - y
        const x2_pdf = x1_pdf + w
        const y2_pdf = y1_pdf - h

        // 步骤2: 应用缩放
        const px1 = x1_pdf * zoom
        const px2 = x2_pdf * zoom
        const py1 = y1_pdf * zoom
        const py2 = y2_pdf * zoom

        // 步骤3: 图片坐标系翻转
        const py1_flip = img_height_zoom - py1
        const py2_flip = img_height_zoom - py2

        // 步骤4: 确定最终矩形坐标
        const left = Math.min(px1, px2)
        const right = Math.max(px1, px2)
        const top = Math.min(py1_flip, py2_flip)
        const bottom = Math.max(py1_flip, py2_flip)

        // 步骤5: 扩大高亮框，避免挡到文字
        const padding = 3 // 增加3像素的内边距
        const expandedLeft = Math.max(0, left - padding)
        const expandedTop = Math.max(0, top - padding)
        const expandedRight = Math.min(img_width_zoom, right + padding)
        const expandedBottom = Math.min(img_height_zoom, bottom + padding)

        return {
          x1: expandedLeft,
          y1: expandedTop,
          x2: expandedRight,
          y2: expandedBottom
        }
      })

      return {
        imgSrc: url,
        highlights,
        pageNum // 添加页面号信息，方便调试
      }
    })
    // 按页面号排序
    return formatted.sort((a, b) => a.pageNum - b.pageNum)
  }

  /* 当组件加载时发起API请求获取page_image_urls */
  useEffect(() => {
    const fetchChunkDetails = async () => {
      let chunk_id = knowledgeTraceInfo?.detail?.[0]?.chunk_id
      if (allHighlights) {
        chunk_id = knowledgeTraceInfo?.cur_trace_file_info?.chunk_id_list?.[0]
      }
      if (!chunk_id) return
      try {
        setSpinLoading(true)
        const res = await getChunkDetailsApi(chunk_id)

        // 直接设置API获取的页面图片URL列表
        setPageImageUrls(res.page_image_urls || [])
      } catch (error) {
        message.error('获取详情信息失败')
      } finally {
        setSpinLoading(false)
        setLoading(false)
      }
    }

    fetchChunkDetails()
  }, [knowledgeTraceInfo?.detail, setLoading])

  /* 处理知识库溯源信息数据 */
  useEffect(() => {
    if (!knowledgeTraceInfo || pageImageUrls.length === 0) return

    // 使用原始的知识库溯源信息作为数据源
    const formattedData = processNewFormat(knowledgeTraceInfo.detail)
    setSliceDataList(formattedData)

    // 找到第一个有高亮内容的页面在完整页面列表中的索引
    const firstHighlightPage = formattedData.find(item => item.highlights && item.highlights.length > 0)
    if (firstHighlightPage) {
      // pageNum是1-based，转换为0-based的页面索引
      const targetIndex = firstHighlightPage.pageNum
      setTargetPageIndex(targetIndex)
      console.log('设置目标页面索引:', targetIndex)
    } else {
      setTargetPageIndex(0)
    }
  }, [knowledgeTraceInfo, pageImageUrls])
  /* 监听targetPageIndex 滑动指定索引 */
  useEffect(() => {
    if (targetPageIndex !== null && pageImageUrls.length > 0) {
      // 添加延迟确保DOM元素已渲染
      const timer = setTimeout(() => {
        const el = imageContainerRefs.current[targetPageIndex]
        if (el) {
          console.log('滚动到页面:', targetPageIndex, 'element:', el)
          // 滚动到页面中心位置，更好地展示高亮内容
          el.scrollIntoView({ behavior: 'smooth', block: 'center' })
        } else {
          console.log('未找到目标元素:', targetPageIndex)
        }
      }, 800)

      return () => clearTimeout(timer)
    }
  }, [targetPageIndex, pageImageUrls])

  return (
    <div className="h-full w-full">
      {/* 加载状态 */}
      {Spinload ? (
        <div className="flexRow absolute top-[10%]  h-[90%] w-full">
          <Spin spinning={Spinload}></Spin>
        </div>
      ) : (
        <div className="caseOverFlowY h-full" ref={containerRef}>
          {/* 页面列表：有高亮的显示canvas，无高亮的显示普通图片 */}
          {pageImageUrls.map((imgUrl, index) => {
            // 检查当前页面是否有高亮数据 (pageNum是1-based，index是0-based)
            const sliceData = sliceDataList.find(it => it.pageNum === index)
            const hasHighlight = !!sliceData && sliceData.highlights && sliceData.highlights.length > 0

            if (hasHighlight) {
              // 获取当前页面的溯源角标
              let chunkIndexs = [knowledgeTraceInfo?.detail?.[0]?.chunk_index]
              if (allHighlights) {
                chunkIndexs = knowledgeTraceInfo?.cur_trace_file_info?.page_num_chunk_index_map?.[index]
                chunkIndexs = chunkIndexs.filter(it => knowledgeTraceInfo?.badges?.includes(it))
              }
              chunkIndexs = _.uniq(chunkIndexs)

              return (
                <div
                  key={index}
                  ref={el => (imageContainerRefs.current[index] = el)}
                  className="relative w-full shadow-sm"
                >
                  <canvas ref={el => (canvasRefs.current[index] = el)} className="mb-2 h-auto w-full" />
                  {/* HTML渲染的溯源角标 */}
                  {chunkIndexs && chunkIndexs.length > 0 && (
                    <div className="absolute left-[30px] top-[30px] z-10 flex gap-2" style={{ zIndex: 1000 }}>
                      {chunkIndexs.map(item => (
                        <div
                          key={item}
                          className=" rounded-[4px] border border-[#5964F3] bg-[#E0E7FF] px-[6px] py-[2px] text-sm font-medium text-[#5964F3]"
                        >
                          溯源[{item}]
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              )
            } else {
              return <img src={imgUrl} key={index} className="mb-2 w-full shadow-sm" />
            }
          })}
        </div>
      )}
    </div>
  )
}

export default HighlighterCom
